/**
 * Atelier Couture — Interactive Size & Fit Calculator
 * Allows toggling between Centimeters and Inches with interactive body measurement inputs.
 */
class SizeGuideCalculator {
  constructor(modal) {
    this.modal = modal;
    this.unitButtons = modal.querySelectorAll('[data-unit-toggle]');
    this.cells = modal.querySelectorAll('[data-val-cm]');
    this.bustInput = modal.querySelector('#quiz-bust');
    this.waistInput = modal.querySelector('#quiz-waist');
    this.hipInput = modal.querySelector('#quiz-hip');
    this.resultEl = modal.querySelector('#quiz-result');

    this.initUnits();
    this.initQuiz();
  }

  initUnits() {
    this.unitButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const unit = btn.getAttribute('data-unit-toggle');
        this.unitButtons.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        this.cells.forEach(cell => {
          const cmVal = parseFloat(cell.getAttribute('data-val-cm'));
          if (unit === 'in') {
            cell.textContent = (cmVal / 2.54).toFixed(1) + '"';
          } else {
            cell.textContent = cmVal + ' cm';
          }
        });
      });
    });
  }

  initQuiz() {
    const calcBtn = this.modal.querySelector('#calculate-size-btn');
    if (!calcBtn || !this.resultEl) return;

    calcBtn.addEventListener('click', () => {
      const bust = parseFloat(this.bustInput?.value || 0);
      const waist = parseFloat(this.waistInput?.value || 0);

      if (!bust || !waist) {
        this.resultEl.textContent = 'Please provide bust and waist measurements.';
        this.resultEl.style.color = '#e07a5f';
        return;
      }

      let recommendedSize = 'M (Atelier 38)';
      if (bust < 86 && waist < 68) recommendedSize = 'XS (Atelier 34)';
      else if (bust < 92 && waist < 74) recommendedSize = 'S (Atelier 36)';
      else if (bust < 98 && waist < 80) recommendedSize = 'M (Atelier 38)';
      else if (bust < 104 && waist < 86) recommendedSize = 'L (Atelier 40)';
      else recommendedSize = 'XL (Atelier 42) / Bespoke Custom';

      this.resultEl.innerHTML = `Recommended Size: <strong style="color: var(--color-gold-primary);">${recommendedSize}</strong>`;
      this.resultEl.style.color = '#fff';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('#size-guide-modal');
  if (modal) new SizeGuideCalculator(modal);
});
